import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Blob, MymeModule } from '@myme/utils';
import { MymeDisplayMode } from './types';
import { useGetMymeParticipation } from '../useGetMymeParticipation';

export const useCurrentMymeData = () => {
  const [mymeId, setMymeId] = useState<string>();
  const [isStartedByUser, setIsStartedByUser] = useState<boolean>(false);
  const [mymeName, setMymeName] = useState('');
  const [currentModuleId, setCurrentModuleId] = useState('');
  const [currentBlob, setCurrentBlob] = useState<Blob | null>(null);
  const [mode, setMode] = useState<MymeDisplayMode>(null);

  const getMymeId = (mymeId: string) => setMymeId(mymeId);
  const getIsStartedByUser = (isStartedByUser: boolean) => setIsStartedByUser(isStartedByUser);
  const getMymeName = (mymeName: string) => setMymeName(mymeName);

  const { mymeId: mymeIdFromPath, blobId: blobIdFromPath } = useParams();

  const {
    data: mymeModules,
    status,
    isFetching: isParticipationFetching
  } = useGetMymeParticipation(mymeId || mymeIdFromPath, isStartedByUser || Boolean(blobIdFromPath));

  useEffect(() => {
    if (!mymeId && mymeIdFromPath) {
      setMymeId(mymeIdFromPath);
    }
  }, []);

  let module: MymeModule | undefined;
  let blob: Blob | undefined;
  if (status === 'success') {
    module = mymeModules?.modules?.find(item => item.blobs.find(blob => !blob.progress.isFinished));
    blob = module?.blobs.find(item => !item.progress.isFinished);
  }
  const showBlobContent = () => {
    setMode('content');
  };

  useEffect(() => {
    // Explanation of expression: activeAfterSeconds ? true : !isFinished
    // This expression is to handle case when user finish time based blob with time and use back 2 times.
    // The blob should set again
    // (if blob set again and user click continue, user get information that he can't continue finished blob )
    // When user go to table content will see correct time to unlock message
    const currentModule = mymeModules?.modules?.find(({ blobs }) =>
      blobs.find(({ id, progress: { isFinished }, activeAfterSeconds }) =>
        id === blobIdFromPath && activeAfterSeconds ? true : !isFinished
      )
    );
    const currentBlob = currentModule?.blobs?.find(({ id, activeAfterSeconds, progress: { isFinished } }) =>
      id === blobIdFromPath && activeAfterSeconds ? true : !isFinished
    );

    if (currentModule?.id && currentBlob) {
      setCurrentModuleId(currentModule?.id);
      showBlobContent();
      setCurrentBlob(currentBlob);
    }

    if (blob && module) {
      setCurrentModuleId(module?.id);
      showBlobContent();
      setCurrentBlob(blob);
    }
  }, [blob, module]);

  useEffect(() => {
    if (Boolean(!blob) && isStartedByUser && status === 'success') {
      setMode('finish');
    }
  }, [blob, isStartedByUser]);

  return {
    mymeId,
    mymeName,
    currentModuleId,
    setCurrentModuleId,
    currentBlob,
    setCurrentBlob,
    mode,
    setMode,
    getMymeId,
    getIsStartedByUser,
    getMymeName,
    blob,
    mymeModules,
    isParticipationFetching
  };
};
